<template>
  <div id="index">
    <keep-alive>
      <router-view to="/index/home"></router-view>
    </keep-alive>
    <FooterView></FooterView>
  </div>
</template>
<script>
import FooterView from "@/components/Footer.vue";
export default {
  name: "Index",
  components: {
    FooterView,
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
#index {
  padding-bottom: 55px;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
#index {
  background: #f6f6f6;
}
</style>
